import { render, staticRenderFns } from "./wageDetailList.vue?vue&type=template&id=1c8a1a8e&scoped=true&"
import script from "./wageDetailList.vue?vue&type=script&lang=js&"
export * from "./wageDetailList.vue?vue&type=script&lang=js&"
import style0 from "./wageDetailList.vue?vue&type=style&index=0&id=1c8a1a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a1a8e",
  null
  
)

export default component.exports